<template>
  <div>
    <div class="msg_head">
      <img src="@/assets/img/device_list/equipment.png" alt="" />
      <span>{{ $t("lang.设备消息") }}</span>
      <el-date-picker
        v-model="queryTime"
        type="month"
        :clearable="false"
        :value-format="'yyyy-MM-dd HH:mm:ss'"
        @change="onChangeMonths"
      >
      </el-date-picker>
    </div>
    <div class="msg_content" v-infinite-scroll="getLoadData">
      <div v-if="msgList.length == 0" class="noNews">
        {{ $t("lang.暂无消息") }}
      </div>
      <div class="msg_item" v-for="(item, index) in msgList" :key="index">
        <p>{{ item.msgTitle }}</p>
        <p>{{ $t("lang.操作时间") }}：{{ item.msgTime }}</p>
        <p>{{ item.msgValue }}</p>
        <p>{{ $t("lang.操作人") }}:{{ item.operatorInfo }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      count: 10,
      queryTime: moment().format("YYYY-MM-01 00:00:00"),
      msgList: [],
      pageNum: 0,
    };
  },
  methods: {
    ...mapActions({
      deviceMessageList: "ZD_DeviceMessageList",
    }),
    async getDeviceMessageList(type) {
      if (type) {
        this.pageNum = 1;
        this.msgList = [];
      }
      let res = await this.deviceMessageList({
        pageNum: this.pageNum,
        pageSize: 15,
        queryTime: this.queryTime,
        msgType: 0,
      });
      if (res.success !== 1) return;
      this.msgList.push(...res.listitem);
    },
    getLoadData() {
      this.pageNum += 1;
      this.getDeviceMessageList();
    },
    onChangeMonths() {
      this.getDeviceMessageList(true);
    },
  },
};
</script>

<style scoped lang='less'>
.msg_head {
  display: flex;
  align-items: center;
  padding: 30px 0 29px 44px;
  border-bottom: 1px solid #ccc;
  img {
    width: 37px;
    height: 37px;
  }
  span {
    font-size: 16px;
    margin: 0 33px 0 20px;
  }
  .el-date-editor {
    width: 157px;
  }
}
.msg_content {
  height: 650px;
  overflow-y: auto;
  .msg_item {
    padding: 31px 40px 29px 44px;
    border-bottom: 1px solid #eee;
  }
  p:nth-of-type(1) {
    font-size: 16px;
    margin-top: 0;
  }
  p:last-child {
    color: #999;
  }
  p {
    font-size: 14px;
    margin-top: 15px;
  }
}
.noNews {
  color: #878787;
  text-align: center;
  padding-top: 50px;
}
</style>